import shopifySparkV2Defaults from '../shopify-spark-v2/config.js';

const { ignoreFields } = shopifySparkV2Defaults.Widgets.find((w) => w.name === 'FacetPanel');
ignoreFields.push('manufacturers');

// client asked to add the FacetPanel widget to https://www.autopartsblvd.com/pages/shop-by-brand and https://www.autopartsblvd.com/collections pages.
// since the FacetTiles widget sends 'facets.json' request, not 'search.json', we need to tell the FacetPanel
// that it can send the initial search request for itself
shopifySparkV2Defaults.Widgets.find((w) => w.name === 'CategoryFacetPanel').needInitRequest = true;

export default {
  includes: ['shopify-spark-v2'],
  ...shopifySparkV2Defaults,
  product: {
    ...shopifySparkV2Defaults.product,
    priceFormatter: {
      // explicitly format product prices in a format accepted by customers
      format: (price) => window.Currency.formatMoney(parseInt(price, 10) * 100, '{{amount_no_decimals}}円'),
    },
  },
  Widgets: [
    ...shopifySparkV2Defaults.Widgets.filter((w) => w.name !== 'FacetBrandTiles'),
    {
      name: 'FacetBrandTiles',
      type: 'FacetTiles',
      location: { selector: '#cm_brands-page', class: 'cm_vehicle-categories__brands' },
      template: 'facetTiles/hierarchicalContainerLetters',
    },
    {
      name: 'FacetManufacturersTiles',
      type: 'FacetTiles',
      location: '.page-vehicle-makes',
      template: 'facetTiles/manufacturersContainer',
      facetField: 'Make',
    },
  ],
};
